var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToastIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10833_749)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9094 11.612L17.1405 19.7048C17.2469 19.7986 17.3757 19.8632 17.5146 19.8922C17.6534 19.9211 17.7974 19.9136 17.9323 19.8702C18.0674 19.8267 18.1887 19.749 18.2846 19.6446C18.3804 19.5401 18.4475 19.4124 18.4793 19.2742L22.6366 1.21595C22.6408 1.19784 22.6398 1.17897 22.6339 1.16135C22.6281 1.14374 22.6175 1.12806 22.6035 1.11597C22.5894 1.10388 22.5723 1.09586 22.554 1.09275C22.5357 1.08964 22.517 1.09158 22.4996 1.09833L1.77303 9.20959C1.64437 9.2591 1.53524 9.34903 1.46202 9.46585C1.3888 9.58268 1.35546 9.7201 1.36698 9.85748C1.37851 9.99487 1.43428 10.1248 1.52594 10.2278C1.6176 10.3308 1.74019 10.4013 1.87531 10.4287L7.9094 11.612Z",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.90906 11.6117L22.576 1.1001",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4469 15.5913L9.31633 18.8395C9.20321 18.9568 9.05762 19.0377 8.89822 19.0718C8.73881 19.1058 8.57287 19.0915 8.42167 19.0307C8.27045 18.9698 8.14088 18.8652 8.04954 18.7301C7.95822 18.5951 7.9093 18.4359 7.90906 18.2729V11.6118",
    stroke: "#42296E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10833_749"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 20.7273,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastIcon);
export default __webpack_public_path__ + "static/media/toast_icon.11c86a59abf3212f2a39d49dde6bc2f5.svg";
export { ForwardRef as ReactComponent };